import { Box, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect } from 'react'
import { Dimensions, FlatList } from 'react-native'
import EmptyView from '../../../comps/EmptyView'
import { SvgImage } from '../../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { getString } from '../../../util/languageStrings'
import { Colors, isOsMobile, logEvent } from '../../../util/util'
import { VoiceBoxList } from '../../VoiceBoxNew/VoiceBoxList'

const height = Dimensions.get('screen').height
export const VoiceBoxListModal = ({ onDismiss }) => {
  const { fetchAllVoiceBoxes, getAllVoiceBoxes, selectedAppLanguage } = useStores((store) => ({
    fetchAllVoiceBoxes: store.voiceBoxes.fetchAllVoiceBoxes,
    getAllVoiceBoxes: store.voiceBoxes.getAllVoiceBoxes,
    selectedAppLanguage: store.settings.config.selectedAppLanguage,
    pairRequests: store.voiceBoxes.pairRequests.slice(),
  }))
  const [getAllVoiceBoxesApi, getAllVoiceBoxesHandler] = useLazyApiData(fetchAllVoiceBoxes)

  const navigation = useNavigation()
  const devices = getAllVoiceBoxes()
  const isFocussed = useIsFocused()

  useEffect(() => {
    if (isFocussed && isOsMobile()) {
      getAllVoiceBoxesApi()
    }
  }, [getAllVoiceBoxesApi, isFocussed])

  useEffect(() => {
    if (getAllVoiceBoxesHandler.state === 'rejected') {
      onDismiss(false)
    }
  }, [getAllVoiceBoxesHandler.state, onDismiss])

  const handleVoiceBox = (device: any) => {
    logEvent('item_press', 'open_voice_box')
    onDismiss(false)
    navigation.navigate(Routes.VOICEBOX, { deviceid: device.id, index: device?.index })
  }
  return (
    <Box
      borderTopLeftRadius={30}
      borderTopRightRadius={30}
      backgroundColor="WHITE"
      overflow={'hidden'}
      p={25}
      height={height / 2}
      pb={10}>
      <Spacer size={10} direction="vertical" />
      <Box flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={20}>
        <Box width={'90%'}>
          <Text fontFamily="JioType-Black" fontSize={24}>
            {getString(selectedAppLanguage, 'myDevices')}
          </Text>
        </Box>
        <Box testID="close-voice-modal" onPress={() => onDismiss(false)} underlayColor={'TRANSPARENT'}>
          <SvgImage imageName="Close" />
        </Box>
      </Box>

      {!devices?.length && getAllVoiceBoxesHandler.state !== 'pending' && (
        <Box alignItems="center" justifyContent={'center'} pv={30}>
          <SvgImage imageName="NoDeviceLinked" />
          <Spacer size={10} direction="vertical" />
          <Text fontFamily="JioType-Bold" fontSize={14} color="BLACK">
            {getString(selectedAppLanguage, 'noDevicesLinked')}
          </Text>
          <Text fontFamily="JioType-Medium" fontSize={12} color={Colors.PRIMARY_GREY}>
            {getString(selectedAppLanguage, 'linkedDevicesNote')}
          </Text>
        </Box>
      )}

      <ModBox show={getAllVoiceBoxesHandler.state === 'pending'} f={1}>
        <EmptyView
          isLoading={getAllVoiceBoxesHandler?.state === 'pending'}
          error={!!getAllVoiceBoxesHandler?.data?.message}
          onRetry={() => getAllVoiceBoxesApi()}
          emptyMessage={'Loading...'}
        />
      </ModBox>
      {getAllVoiceBoxesHandler?.state === 'fulfilled' && (
        <FlatList
          data={devices}
          renderItem={({ item, index }: any) => (
            <VoiceBoxList
              data={item}
              index={index}
              allVoiceBoxesHandler={getAllVoiceBoxesHandler}
              onProceed={handleVoiceBox}
            />
          )}
          extraData={devices}
        />
      )}
    </Box>
  )
}
